var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogleSearch1818 = function SvgGoogleSearch1818(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC107",
    d: "M16.354 7.531h-.604V7.5H9v3h4.239A4.498 4.498 0 0 1 4.5 9 4.5 4.5 0 0 1 9 4.5c1.147 0 2.19.433 2.985 1.14l2.122-2.122A7.47 7.47 0 0 0 9 1.5a7.5 7.5 0 1 0 7.354 6.031"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF3D00",
    d: "m2.365 5.51 2.464 1.806A4.5 4.5 0 0 1 9 4.5c1.147 0 2.19.433 2.985 1.14l2.122-2.122A7.47 7.47 0 0 0 9 1.5a7.5 7.5 0 0 0-6.635 4.01"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4CAF50",
    d: "M9 16.5a7.47 7.47 0 0 0 5.028-1.947l-2.32-1.964A4.47 4.47 0 0 1 9 13.5a4.5 4.5 0 0 1-4.231-2.98l-2.446 1.885A7.49 7.49 0 0 0 9 16.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1976D2",
    d: "M16.354 7.531h-.604V7.5H9v3h4.239a4.5 4.5 0 0 1-1.533 2.09l.001-.002 2.321 1.965C13.864 14.702 16.5 12.75 16.5 9c0-.503-.052-.994-.146-1.469"
  })));
};
export default SvgGoogleSearch1818;